"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.H4 = exports.Heading4 = exports.H3 = exports.Heading3 = exports.H2 = exports.Heading2 = exports.H1 = exports.Heading1 = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Heading1 = ({ children, className }) => {
    return react_1.default.createElement("h1", { className: (0, classnames_1.default)('mb-3 font-display text-4xl font-bold', className) }, children);
};
exports.Heading1 = Heading1;
exports.H1 = exports.Heading1;
const Heading2 = ({ children, className }) => {
    return react_1.default.createElement("h2", { className: (0, classnames_1.default)('mb-3 font-display text-2xl font-bold', className) }, children);
};
exports.Heading2 = Heading2;
exports.H2 = exports.Heading2;
const Heading3 = ({ children, className }) => {
    return react_1.default.createElement("h3", { className: (0, classnames_1.default)('mb-3 font-display text-lg font-bold', className) }, children);
};
exports.Heading3 = Heading3;
exports.H3 = exports.Heading3;
const Heading4 = ({ children, className }) => {
    return react_1.default.createElement("h4", { className: (0, classnames_1.default)('mb-3 font-display text-base font-bold', className) }, children);
};
exports.Heading4 = Heading4;
exports.H4 = exports.Heading4;
